import { Button } from '@mosey/components/buttons/Button';
import { GuidedStepContentProps } from './types';

export const VECAccountTypeStep = ({ nextStep }: GuidedStepContentProps) => {
  return (
    <div className="mt-8 flex flex-col items-start gap-8">
      <h5 className="text-2xl font-semibold tracking-tight">
        Select Account Type
      </h5>

      <p className="max-w-xl">
        Once you are prompted for your account type, select &ldquo;VEC&rdquo;.
      </p>

      <Button onClick={nextStep}>Next</Button>
    </div>
  );
};
